import { put } from "@/api";

/** 购物车提交规格行 */
export interface CartSubmitSpec {
  /** 商品规格 ID */
  id: number | string;
  /** 规格名称 */
  name: string;
  /** 商品 ID */
  goods_id: number | string;
  /** 商品名称 */
  goods_name: string;
  quantity: number;
  remark?: string;
}

export interface CartSubmitParams {
  specs: CartSubmitSpec[];
  remark?: string;
}

export interface CartSubmitResult {
  order_sn?: string | null;
  order_id?: number | string | null;
}

export interface CartSubmitResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  errors?: Record<string, string[]>;
  data?: CartSubmitResult;
}

/** 提交购物车采购单 */
export function submitCart(params: CartSubmitParams) {
  return put<CartSubmitResponse>("/platform/cart/submit", params);
}

/** 代购下单参数 */
export interface CartDivideParams extends CartSubmitParams {
  /** 结算科室 ID */
  department_id: number | string;
  /** 下单人账号 ID */
  account_id: number | string;
}

/** 指定下单（代购） */
export function submitDivideCart(params: CartDivideParams) {
  return put<CartSubmitResponse>("/platform/cart/divide", params);
}
